const initialState = {
  fetching: false,
  fetched: false,
  items: [],
  eventIds: [],
  error: null,
  nbResult: 0,
  paginationPage: 1,
  paginationTotalPages: 1
};
export const eventsReducer = (state = initialState, action) => {
  switch (action.type) {
    case `RESET_EVENTS`: {
      return initialState;
    }
    case `FETCH_EVENTS_PENDING`: {
      return { ...state, fetched: false, fetching: true };
    }
    case `FETCH_EVENTS_FULFILLED`: {
      const { data, nbResult } = action.payload.data;
      /*let result = [...data];
      const { eventIds } = state;

      if (eventIds && eventIds.length > 0) {
        result = eventIds.map(id => {
          for (let i = 0; i < data.length; i++) {
            if (parseInt(id, 10) === parseInt(data[i].id, 10)) {
              return { ...data[i] };
            }
          }
        });
      }*/

      return {
        ...state,
        fetching: false,
        fetched: true,
        error: null,
        items: [...data], //result.filter(res => res !== undefined),
        nbResult: nbResult
      };
    }
    case `FETCH_EVENTS_REJECTED`: {
      let error = action.payload;
      switch (error.response.status) {
        case 404:
          error = {
            title: error.response.data.title,
            code: 404
          };
          break;
        default:
      }
      return {
        ...state,
        fetching: false,
        error,
        items: [],
        nbResult: 0
      };
    }
    case `FETCH_EVENT_IDS_FULFILLED`: {
      const { data } = action.payload.data;
      return {
        ...state,
        eventIds: data && data.events ? data.events : []
      };
    }
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/event.js